import React, { useState } from "react";
import { MdClose } from "react-icons/md";
import { toast } from "react-toastify";
import { adminApiService } from "services/api";

const AddCategoryModal = ({
  toggleAddCategory,
  showAddCategory,
  onCategoryAdded,
}) => {
  const [categoryName, setCategoryName] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    const bodyData = {
      categoryName: categoryName,
    };

    try {
      const response = await adminApiService.addCategory(bodyData);

      if (!response.ok) throw new Error("Network response was not ok");
      await response.json();
      toast.success("Category added successfully!");
      resetFormFields();
      toggleAddCategory();
      onCategoryAdded();
    } catch (error) {
      console.error("Error:", error);
      toast.error(`Failed to add category: ${error.message}`);
    }
  };

  const resetFormFields = () => {
    setCategoryName("");
  };

  const closingModal = () => {
    resetFormFields();
    toggleAddCategory();
  };

  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-navy-900 opacity-50"
        onClick={toggleAddCategory}
      ></div>

      <div
        className={`fixed right-0 top-0 h-screen w-2/3 transform bg-white transition-transform ${
          showAddCategory ? "translate-x-0" : "translate-x-full"
        } z-50 shadow-lg`}
      >
        <div className="flex h-full flex-col bg-navy-700">
          <div className="flex items-center justify-between bg-gray-500 p-3 shadow-md">
            <div className="flex-col">
              <h1 className="text-xl">Add Category</h1>
              <h1 className="text-lg">Add a new category from here</h1>
            </div>
            <MdClose
              className="cursor-pointer rounded-full bg-navy-900 p-1 text-3xl text-white"
              onClick={closingModal}
            />
          </div>

          <form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="no-scrollbar h-full flex-col items-center overflow-y-scroll p-5 "
          >
            <div className="mb-5 flex w-full items-center justify-between">
              <h1 className="w-2/5 text-lg text-white">Category Name</h1>
              <input
                className="w-3/5 rounded-md p-2"
                type="text"
                placeholder="Category Name"
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
              />
            </div>

            <div className="mt-10 flex flex-wrap justify-center gap-2">
              <button
                type="submit"
                className="w-1/2 rounded-md bg-primary p-2 text-lg text-white"
              >
                Add Category
              </button>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default AddCategoryModal;
